var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerExpanded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,25v-4h28v4H0ZM35.97,22.83l-10.83-10.83L35.97,1.17l3.03,3.03-7.8,7.8,7.8,7.8-3.03,3.03ZM0,14v-4h21v4H0ZM0,4V0h28v4H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerExpanded);
export default __webpack_public_path__ + "static/media/HamburgerExpanded.42286676daa268f732b17557079a3b0e.svg";
export { ForwardRef as ReactComponent };